module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAUCAYAAAAqVKv2AAAAAXNSR0IArs4c6QAAAV1JREFUWEftlk1SwzAMhWXDnvQcJbRMr8HQgfufhIXE+C+RE7vz3A4bRpkuUlmWrc9PchzZAxFwkJc5kYECRWCgDBRIAHQzRRkokADoZooyUCAB0M0UZaBAAqCbKeoRUD8v8+XJuQ8i7MudyVP4LY/Pf7wnLsbFFgxlnIiLPZpVkPzO0aTjp/cQ17fi5zhx3c7cuCW9FgBrpyiZTu9M8olCCmtEUCr/ZRNVsjrhNdkKwgZUlWwj8XshPwxKpvOZia9jkBbJNE5QKWZ7ugWiVsstRbVAteaWdcIB/oWiZDqeiJ6vTKKLCBBlVtRQ6a3qSqopk1WJ5SSr8U3imKI68QfLL5aeHOaZxX/RHZBS6bX7S+kR+/HVvz83wduDqhNPqumvn3pkOQB9EGN6cHJ4e2WRbyI3NlNprd6M2jTSzLsXgVaq7oFrstUlMnARLFsfaOj2eQA1F/D6B2P9a7dfFt88017mbo4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/filtrate_line.png
// module id = m2SN
// module chunks = 0